var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 3a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h10.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75zm5.797 4.238a.748.748 0 0 0-1.094 0l-4 4.25a.75.75 0 0 0 1.09 1.028L9.25 9.641v6.61c0 .415.334.75.75.75s.75-.335.75-.75V9.64l2.703 2.872a.75.75 0 0 0 1.09-1.028l-4-4.25z"
  })));
};
export default SvgUpload;